// Polyfill.
import "core-js/stable";
import "regenerator-runtime/runtime";
// Top components.
import AsyncAction from "./react/AsyncAction";
import CatalogAssignmentViewer from "./react/CatalogAssignmentViewer";
import CatalogEmailTemplateViewer from "./react/CatalogEmailTemplateViewer";
import CatalogTreatmentViewer from "./react/CatalogTreatmentViewer";
import CriteriaConfigurer from "./react/settings/CriteriaConfigurer";
import CustomerSupport from "./react/CustomerSupport";
import EmailTemplateEditor from "./react/EmailTemplateEditor";
import GenericRegistrationForm from "./react/GenericRegistrationForm";
import MetadataViewer from "./react/MetadataViewer";
import ModalFlowLauncher from "./react/flow/ModalFlowLauncher";
import PatientInformation from "./react/PatientInformation";
import PatientAppointments from "./react/patient-portal/PatientAppointments";
import PaginatedList from "./react/PaginatedList";
import PatientList from "./react/PatientList";
import PatientManagement from "./react/patient-profile/PatientManagement";
import PracticeManagementViewer from "./react/PracticeManagementViewer";
import PatientFullDetails from "./react/patient-management/PatientFullDetails";
import PatientDashboard from "./react/patient-portal/PatientDashboard";
import PrintableAssessmentResult from "./react/PrintableAssessmentResult";
import AssessmentResult from "./react/AssessmentResult";
import Reports from "./react/Reports";
import SettingsAccount from "./react/SettingsAccount";
import SettingsNotification from "./react/SettingsNotification";
import SettingsVideoConsultation from "./react/SettingsVideoConsultation";
import SettingsVirtualConsultationIntegration from "./react/flow-management/SettingsVirtualConsultationIntegration";
import SettingsVirtualConsultationCustomisation from "./react/SettingsVirtualConsultationCustomisation";
import SignIn from "./react/SignIn";
import TermsAndConditionsForm from "./react/TermsAndConditionsForm";
import TreatmentEditor from "./react/TreatmentEditor";
import Troubleshoot from "./react/Troubleshoot";
import PublicSignIn from "./react/PublicSignIn";
import UserList from "./react/UserList";
import UserProfile from "./react/UserProfile";
import UserWithPracticeRegistrationForm from "./react/UserWithPracticeRegistrationForm";
import UserIdentity from "./react/commons/components/user/UserIdentity";
import Payment from "./react/Payments";
// Misc scripts.
import * as VerticalDropDown from "./js/vertical-dropdown-manager";
// Style.
import "./styles/base/bundle.scss";
import ConvertToPatientForm from "./react/patient-management/ConvertToPatientForm";

export default {
  AsyncAction,
  CatalogAssignmentViewer,
  CatalogEmailTemplateViewer,
  CatalogTreatmentViewer,
  CriteriaConfigurer,
  CustomerSupport,
  EmailTemplateEditor,
  GenericRegistrationForm,
  MetadataViewer,
  ModalFlowLauncher,
  PatientDashboard,
  PatientInformation,
  PatientAppointments,
  PaginatedList,
  PatientList,
  PatientManagement,
  PatientFullDetails,
  Payment,
  PracticeManagementViewer,
  PrintableScreeningReport: PrintableAssessmentResult,
  AssessmentResult: AssessmentResult,
  Reports: Reports,
  SettingsAccount,
  SettingsNotification,
  SettingsVideoConsultation,
  SettingsVirtualConsultationIntegration,
  SettingsVirtualConsultationCustomisation,
  SignIn,
  TermsAndConditionsForm,
  TreatmentEditor,
  Troubleshoot,
  PublicSignIn,
  UserList,
  UserProfile,
  UserIdentity,
  UserWithPracticeRegistrationForm,
  VerticalDropDown,
  ConvertToPatientForm,
};
